import './nuevoStroLight.css';
import ActualizarDenunciaLight from './ActualizarDenunciaLight';
import { useContext, useState } from 'react';
import { useCookies } from 'react-cookie';
import CronologiaLight from './CronologiaLight';
import FrenteLight from './FrenteLight';
import SicobeLight from './SicobeLight';
import TablaOtrasDenunciasLight from './TablaOtrasDenunciasLight';
import EndososLight from './EndososLight';
import PlanillaReclamosLight from './PlanillaReclamosLight';
import SlideCargasLight from './SlideCargasLight';
import VerTodoDenunciaLight from './VerTodoDenunciaLight';
import SlideContractualesLight from './SlideContractualesLight';
/* Iconos */
import ampliaciones from '../../../images/iconosPanelIzq/logo_ampliaciones.svg';
import cargasEdicion from '../../../images/iconosPanelIzq/icono-contractuales-light.svg';
import chat from '../../../images/iconosPanelIzq/logo_chat.svg';
import dark from '../../../images/iconosPanelIzq/logo_dark.svg';
import editar from '../../../images/iconosPanelIzq/logo_editar.svg';
import endosos from '../../../images/iconosPanelIzq/logo_endosos.svg';
import frente from '../../../images/iconosPanelIzq/logo_frente.svg';
import pagos from '../../../images/iconosPanelIzq/icono-sicobe-light.svg';
import siniestros from '../../../images/iconosPanelIzq/icono-siniestro-light.svg';
import verTodo from '../../../images/iconosPanelIzq/logo_vertodo.svg';
import planillaReclamos from '../../../images/iconosPanelIzq/icono_reclamo.svg';
//
import { ThemeContext } from '../../../context/Theme';
export default function PanelIzqStroLight({ stro, carga4, reclamo, carga3, estados, estadosCodigos, planilla, setPlanilla, nuevoReclamo, setNuevoReclamo, reclamos }) {
  const [render, setRender] = useState(0);
  const [cookies] = useCookies(['user'], ['asignado']);
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
  const qnxInic = formatDate(stro?.qnx?.ados_fech_ini);
  const qnxFin = formatDate(stro?.qnx?.ados_fech_fin);
  const fechaStro = formatDate(stro?.fechaStro);
  const handleOpenInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const handleOpenInSameTab = url => {
    window.open(url, '_self');
  };
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [reclamoSiniestro, setReclamoSiniestro] = useState(0);

  return (
    <section className='panelIzqStroLightContainer'>
      {nuevoReclamo ? <div className='overlayOscuroInterno'></div> : null}
      {/* Slides */}
      {/* Ver todo */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight1' aria-labelledby='offcanvasRightLabel1'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <VerTodoDenunciaLight />
        </div>
      </div>
      {/* Actualizar*/}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight' aria-labelledby='offcanvasRightLabel'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>{cookies?.user?.titulo !== 'lector' ? <ActualizarDenunciaLight /> : null}</div>
      </div>
      {/* Cronologia*/}
      <div class='offcanvas offcanvas-end w-50' data-bs-backdrop='false' tabindex='-1' id='offcanvasRight2' aria-labelledby='offcanvasRightLabel2'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <CronologiaLight denuncia={stro} cookies={cookies} />
        </div>
      </div>
      {/* Frente */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight3' aria-labelledby='offcanvasRightLabel3'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <FrenteLight />
        </div>
      </div>
      {/* Sicobe */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight4' aria-labelledby='offcanvasRightLabel4'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <SicobeLight />
        </div>
      </div>
      {/* Siniestros */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight5' aria-labelledby='offcanvasRightLabel5'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <TablaOtrasDenunciasLight />
        </div>
      </div>
      {/* Endosos */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight6' aria-labelledby='offcanvasRightLabel6'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <EndososLight />
        </div>
      </div>
      {/* PlanillaReclamos */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight7' aria-labelledby='offcanvasRightLabel7'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <PlanillaReclamosLight reclamo={reclamo} carga4={carga4} denuncia={stro} />
        </div>
      </div>
      {/* Slide Cargas */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight8' aria-labelledby='offcanvasRightLabel8'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          {cookies.user.depto === 'cargas' ? (
            <SlideContractualesLight denuncia={stro} carga3={carga3} estadosCodigos={estadosCodigos} estadosValores={estados} />
          ) : (
            <SlideCargasLight stro={stro} qnxFin={qnxFin} qnxInic={qnxInic} fechaStro={fechaStro} />
          )}
        </div>
      </div>
      {/* Panel */}
      <div className="sidebar-inner-container">
        {/* Brand */}
        <div className="sidebar-brand">
          <div className="sidebar-brand-icon">
            <i className="bi bi-shield-check"></i>
          </div>
          <div>
            <div className="sidebar-brand-text">AGS Seguros</div>
            <div className="sidebar-brand-sub">Detalle de Siniestro</div>
          </div>
        </div>

        {/* User Profile */}
        <div className="sidebar-user">
          <div className="sidebar-avatar">
            {cookies?.user?.usuario ? cookies.user.usuario.substring(0, 2).toUpperCase() : '?'}
          </div>
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{cookies?.user?.usuario || 'Usuario'}</span>
            <span className="sidebar-user-role">{cookies?.user?.depto || 'Departamento'}</span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <span className="sidebar-nav-label">Operaciones</span>

          {cookies?.user?.titulo !== 'lector' ? (
            <button
              className="sidebar-nav-item"
              disabled={cookies?.user?.depto === 'emision'}
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              <i className="bi bi-pencil-square"></i>
              Editar Siniestro
            </button>
          ) : null}

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight1"
            aria-controls="offcanvasRight1"
          >
            <i className="bi bi-eye"></i>
            Ver Todo
          </button>

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight2"
            aria-controls="offcanvasRight2"
          >
            <i className="bi bi-chat-dots"></i>
            Chat / Historial
          </button>

          <span className="sidebar-nav-label">Consultas</span>

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight3"
            aria-controls="offcanvasRight3"
          >
            <i className="bi bi-folder2"></i>
            Frente
          </button>

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight4"
            aria-controls="offcanvasRight4"
          >
            <i className="bi bi-cash-stack"></i>
            Sicobe
          </button>

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight5"
            aria-controls="offcanvasRight5"
          >
            <i className="bi bi-shield-fill-exclamation"></i>
            Otros Siniestros
          </button>

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight6"
            aria-controls="offcanvasRight6"
          >
            <i className="bi bi-file-earmark-text"></i>
            Endosos
          </button>

          <button
            className="sidebar-nav-item"
            onClick={() => setReclamoSiniestro(1)}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight7"
            aria-controls="offcanvasRight7"
          >
            <i className="bi bi-file-spreadsheet"></i>
            Planilla Reclamo
          </button>

          <button
            className="sidebar-nav-item"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight8"
            aria-controls="offcanvasRight8"
          >
            <i className="bi bi-inbox"></i>
            Slide Cargas
          </button>

          <button
            className="sidebar-nav-item"
            onClick={() => handleOpenInNewTab('/#/ampliaciones')}
            type="button"
          >
            <i className="bi bi-arrows-expand"></i>
            Ampliaciones
          </button>

          <span className="sidebar-nav-label">Vistas</span>

          {(reclamos?.some(r => r.idReclamo !== null) || planilla === 1) && (
            <>
              <button
                className={`sidebar-nav-item ${planilla === 0 ? 'active' : ''}`}
                onClick={() => setPlanilla(0)}
                type="button"
              >
                <i className="bi bi-info-circle"></i>
                Vista Siniestro
              </button>
              <button
                className={`sidebar-nav-item ${planilla === 1 ? 'active' : ''}`}
                onClick={() => setPlanilla(1)}
                type="button"
              >
                <i className="bi bi-megaphone"></i>
                Vista Reclamo
              </button>
            </>
          )}

          <button
            className="sidebar-nav-item"
            onClick={() => handleOpenInSameTab('/#/')}
            type="button"
          >
            <i className="bi bi-arrow-left"></i>
            Volver a Tabla
          </button>

          <button
            className="sidebar-nav-item"
            onClick={toggleTheme}
            type="button"
          >
            <i className={`bi ${theme === 1 ? 'bi-moon-fill' : 'bi-sun-fill'}`}></i>
            {theme === 1 ? 'Modo Oscuro' : 'Modo Claro'}
          </button>
        </nav>
      </div>
    </section>
  );
}
